import { t } from "@impero-com/common/utils/i18n";
import i18next from "i18next";
import { keyBy } from "lodash-es";

import type { Locale } from "api/generated/model";

interface CultureInformation {
    name: Locale;
    label: string;
}

export function getCurrentLanguage(): string {
    return i18next.language;
}

const cultureInformation: Array<CultureInformation> = [];

function getCultureInformation(): Array<CultureInformation> {
    if (cultureInformation.length <= 0) {
        cultureInformation.push({
            name: "en",
            label: t("Language_English"),
        });
        cultureInformation.push({
            name: "da",
            label: t("Language_Danish"),
        });
        cultureInformation.push({
            name: "de",
            label: t("Language_German"),
        });
        cultureInformation.push({
            name: "es",
            label: t("Language_Spanish"),
        });
        cultureInformation.push({
            name: "fr",
            label: t("Language_French"),
        });
    }
    return cultureInformation;
}

const cultureInformationIndexes: {
    [prop: string]: { [value: string]: CultureInformation };
} = {};

function getCultureInformationByName(
    name: string
): CultureInformation | undefined {
    let index = cultureInformationIndexes["name"];
    if (!index) {
        cultureInformationIndexes["name"] = index = keyBy(
            getCultureInformation(),
            (info) => info.name
        );
    }
    return index[name];
}

function getCultureInformationByLabel(
    label: string
): CultureInformation | undefined {
    let index = cultureInformationIndexes["label"];
    if (!index) {
        cultureInformationIndexes["label"] = index = keyBy(
            getCultureInformation(),
            (info) => info.label
        );
    }
    return index[label];
}

export {
    getCultureInformation,
    getCultureInformationByName,
    getCultureInformationByLabel,
};
